import { Box, Card, makeStyles } from "@material-ui/core";
import {
  DeleteWithConfirmButton,
  EditProps,
  SaveButton,
  Toolbar,
  ToolbarProps,
  useEditContext,
  useRecordContext,
} from "react-admin";
import { DefaultEdit } from "../../components/DefaultEdit";
import { DownloadXmlButton } from "../components/DownloadXmlButton";
import { InvoiceForm } from "./InvoiceForm";
import {ResetXmlButton} from "../components/ResetXmlButton";
import {SyncPaymentScheduleButton} from "../components/SyncPaymentScheduleButton";
import {useFormState} from "react-final-form";
const useStyles = makeStyles((theme) => ({
  toolbar: { display: "flex", justifyContent: "flex-end" },
}));

const CustomToolbar = (props: ToolbarProps) => {
  const classes = useStyles();
  const record = useRecordContext();
  const { refetch } = useEditContext();
  const {dirty} = useFormState();
  const paymentLocked = record?.invoice_type === "P" && ["P", "PP"].includes(record.status);
  return record ? (
    <Toolbar {...props} classes={classes}>
      <>
        <Box display="flex" flex="1">
          <DownloadXmlButton onSuccess={refetch!} />
        </Box>
      </>
        <>
            <Box display="flex" flex="1">
                <ResetXmlButton onSuccess={refetch!} />
            </Box>
        </>
      <SyncPaymentScheduleButton disabled={dirty} title={dirty ? "Salva prima le modifiche alla fattura" : undefined} />
      {record && (record.status === "C" || paymentLocked) ? null : <SaveButton />}
      {record && (record.status === "C" || paymentLocked) ? null : (
        <DeleteWithConfirmButton mutationMode="pessimistic" />
      )}
    </Toolbar>
  ) : null;
};

export const InvoiceEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props} component={Card}>
      <InvoiceForm toolbar={<CustomToolbar />} />
    </DefaultEdit>
  );
};
